import { api } from './client'

/** R5-12 - fatturato reale per anno (api/reports/annual-revenue). Solo Admin/Direzione/amministrazione: gli altri ricevono 403. */
export interface RevenueMonth {
  month: number
  signed: number
  paid: number
  paidValue: number
  /** Valore lordo (expected_amount, il VALORE del foglio) delle pratiche pagate. */
  grossValue: number
  commissionBasis: number
  payments: number
  storni: number
  recurring: number
  net: number
}

export interface RevenueYear extends Omit<RevenueMonth, 'month'> {
  year: number
  months: RevenueMonth[]
}

export interface AnnualRevenue {
  currentYear: number
  years: RevenueYear[]
}

export const fetchAnnualRevenue = (): Promise<AnnualRevenue> => api<AnnualRevenue>('/api/reports/annual-revenue')
